import { useQuery } from "@tanstack/react-query";
import { fetchArticles, fetchMonetization } from "@/lib/api";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { FeaturedBento } from "@/components/FeaturedBento";
import { Manifesto } from "@/components/Manifesto";
import { ArticleExplorer } from "@/components/ArticleExplorer";
import { SponsoredSection } from "@/components/SponsoredSection";
import { Newsletter } from "@/components/Newsletter";
import { LeaderboardAd } from "@/components/AdSlot";
import { useSEO } from "@/hooks/useSEO";

export default function Home() {
    useSEO({
        title: "Investidor Comum — Educação financeira sem jargão",
        description: "Guias diretos sobre orçamento, renda fixa, dividendos, FIIs e independência financeira. Sem promessa de enriquecimento rápido — só método, matemática e paciência.",
        url: window.location.origin,
    });

    const { data: featured = [] } = useQuery({
        queryKey: ["featured"],
        queryFn: () => fetchArticles({ featured: true }),
    });

    return (
        <main>
            <Hero />
            <EditorialMarquee />
            <FeaturedBento articles={featured} />
            <div className="max-w-7xl mx-auto px-4 md:px-8 pb-4">
                <LeaderboardAd />
            </div>
            <Manifesto />
            <ArticleExplorer />
            <SponsoredSection />
            <Newsletter />
        </main>
    );
}
